import { createSelector } from '@reduxjs/toolkit';
import { State } from '../../../store/state';

export const articleSelector = (state: State) => state.article.article;
export const optionsSelector = (state: State) => state.article.options;
export const totalSelector = (state: State) => state.article.total;
export const noMoreSelector = (state: State) => state.article.noMore;
export const pageSelector = (state: State) => state.article.page;
export const errorCodeSelector = (state: State) => state.article.errorCode;

const articlesIdsSelector = (state: State) => state.article.articles.ids;
const articlesEntitiesSelector = (state: State) =>
  state.article.articles.entities;

export const articlesSelector = createSelector(
  [articlesIdsSelector, articlesEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);

const classifiedArticlesIdsSelector = (state: State) => state.article.classifiedArticles.ids;
const classifiedArticlesEntitiesSelector = (state: State) =>
  state.article.classifiedArticles.entities;

export const classifiedArticlesSelector = createSelector(
  [classifiedArticlesIdsSelector, classifiedArticlesEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);